// extracted by mini-css-extract-plugin
export default {"menuButton":"ProcessDiagramEdit_menuButton__tShu6","sparkleIcon":"ProcessDiagramEdit_sparkleIcon__aLJDu"};